import { setSessionStorageItem } from '../../sessionStorage/utils';
import { SESSION_STORAGE_SEARCH_TYPE } from '../../../utils/constants';

export default (searchTypeVar) => {
  return (newSearchType) => {
    searchTypeVar(newSearchType);
    setSessionStorageItem(SESSION_STORAGE_SEARCH_TYPE, newSearchType);
  };
};
